module.exports = "/_next/static/images/game-1-intro-tutorial-suspect1-2679b42d291d8dfc378b509f90a4ba37.jpg";